import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";

import * as actions from "../constants/actions";
import { getBodyOverflow } from "../selectors";
import Layout from "../components/Layout";

const mapStateToProps = state => ({
  authLoaded: state.auth.loaded,
  authLoggedIn: state.auth.loggedIn,
  headerHidden: state.ui.headerHidden,
  bodyOverflow: getBodyOverflow(state),
  leftSidebarOpen: state.ui.leftSidebarOpen,
  rightSidebarOpen: state.ui.rightSidebarOpen,
  lng:  state.locale.lng
});


const mapDispatchToProps = dispatch => ({
  openUILeftSidebar: () => dispatch(actions.openUILeftSidebar()),
  closeUILeftSidebar: () => dispatch(actions.closeUILeftSidebar()),
  openUIRightSidebar: () => dispatch(actions.openUIRightSidebar()),
  closeUIRightSidebar: () => dispatch(actions.closeUIRightSidebar()),
  openModal: payload => dispatch(actions.openModal(payload)),
  signout: () => dispatch(actions.signout()),
  deleteUser: () => dispatch(actions.deleteUser())
});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);
const withRouterComponent = withRouter(connectedComponent);
const withTranslationComponent = withTranslation("layout", "account", "common")(withRouterComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/Layout.js